import store from './../../store'
import UserCookie from 'vue-cookies'

// Safe nested lookup compatible with older Node versions (pre-v14)
const getMembType = () => {
    const state = store.state
    if (state && state.getUserData && state.getUserData.getUserInfo && state.getUserData.getUserInfo.USER_DATA) {
        return state.getUserData.getUserInfo.USER_DATA.MEMB_TYPE
    }
    return undefined
}

export default async function isUserPrincipal({ next }) {
    try {
        const MEMBN = UserCookie.get('usermembn')

        // Fetch user data if it hasn't been loaded into the store yet
        if (getMembType() === undefined) {
            await store.dispatch('userInfo', { MEMBN })
        }

        // Allow navigation only if member type is explicitly null
        if (getMembType() === null) {
            return next()
        }

        return next('/404')
    } catch (error) {
        console.error('isUserPrincipal middleware error:', error)
        return next('/404')
    }
}
